"use client";

import * as React from "react";
import Image from "next/image";
import { useColorScheme } from "@mui/material";

export default function Logo({
  height = 30,
  width = 180,
  darkMode,
}: {
  height?: number;
  width?: number;
  darkMode?: boolean;
}) {
  const { mode, systemMode } = useColorScheme();

  let isDarkMode =
    mode === "dark" || (mode === "system" && systemMode === "dark");

  if (darkMode !== undefined && darkMode !== null) {
    isDarkMode = darkMode;
  }

  return isDarkMode ? (
    <Image src="/LogoDark.svg" height={height} width={width} alt="Logo Dark" />
  ) : (
    <Image src="/Logo.svg" height={height} width={width} alt="Logo" />
  );
}
